import { EventEmitter } from 'events';
import { FeatureCollection, Polygon } from 'geojson';
import PolygonLoader from '../loaders/PolygonsLoader';

const polygonLoader = new PolygonLoader();

export default class ParkLotGeoJSONProcessor extends EventEmitter implements IFileProcessor {
  public process(file: File) {
    const reader = new FileReader();
    reader.onload = () => {
      try {
        const data = JSON.parse(reader.result) as FeatureCollection<Polygon>;
        data.features.forEach(feature => {
          polygonLoader.addPolygon(feature.geometry.coordinates[0] as ILngLat[]);
        });
      } catch (err) {
        this.emit('error', err);
      }
    };
    reader.readAsText(file);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/processors/ParkLotGeoJSONProcessor.ts